import { gql } from "@apollo/client";

export const GET_CATEGORIES = gql`
  query GetCategories($filters: [CategoryFilter!]) {
    categories(filters: $filters, pagination: { limit: 1000 }) {
      items {
        id
        slug
        title
        parent {
          id
          slug
        }
        coverImage: image(type: COVER) {
          id
          url
        }
        detailImage: image(type: DETAIL) {
          id
          url
        }
        images {
          url
          id
        }
        items {
          id
          slug
          title
        }
      }
    }
  }
`;

export const GET_PRODUCT_CATEGORIES = gql`
  query ProductCategories {
    products {
      items {
        categories {
          title
          id
          slug
          images {
            url
            id
          }
          items {
            slug
            title
            id
          }
        }
      }
    }
  }
`;
